export const ModalConst = {
    CONFIRM: 0,
    CLOSE: 1,
    FINISH: 2
}